<div class="gamecontainer" style="min-height: 100%; font-family: 'Open Sans';">
    <div class="top-nav-bar">
      <div class="top-nav-barmenu">
        <a *ngFor="let item of items" [routerLink]="item.routerLink"
              [routerLinkActive]="['active']">{{item.title}}</a>
      </div>
    </div>
    <div class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
  
  </div>